import { Helmet } from "react-helmet"
import { ToastContainer } from "react-toastify"
import {
    ActionButtons,
    BatchInputForm,
    Instructions,
    ResultsSummary
} from "../../components/batch"
import { Header } from "../../components/common"
import Footer from "../../components/footer/Footer"
import { useBatchProcessing } from "../../hooks/useBatchProcessing"

export default function BatchTrackingScreen() {
    const {
        batchInput,
        setBatchInput,
        isProcessing,
        results,
        processingType,
        setProcessingType,
        processBatch,
        clearData,
        getInputLineCount
    } = useBatchProcessing()

    return (
        <>
            <Helmet>
                <title>LogPlace - Rastreamento em Massa B2B</title>
                <meta
                    name="description"
                    content="Processe centenas de rastreamentos simultaneamente e obtenha relatórios completos em Excel. Ideal para operações B2B e análises em escala."
                />
                <meta
                    name="keywords"
                    content="rastreamento em massa, consulta lote, B2B, relatórios Excel, logística, fulfillment, análise dados"
                />
                <meta name="author" content="LogPlace" />
                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1.0"
                />
            </Helmet>

            <div className="relative flex flex-col flex-1 w-full min-h-screen overflow-y-auto bg-white">
                <ToastContainer
                    position="bottom-right"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    icon={false}
                    limit={1}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />

                <Header />

                {/* Main Content */}
                <div className="flex-1 px-4 xl:px-44 py-8 bg-gradient-to-b from-white from-1% via-secondary-1 via-30% via-secondary-2 via-30% to-primary to-80%">
                    <div className="max-w-6xl mx-auto">
                        {/* Title */}
                        <div className="text-center mb-8">
                            <h1 className="text-4xl font-bold text-gray-800 mb-4">
                                Rastreamento em Massa
                            </h1>
                            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
                                Processe múltiplas consultas e gere relatórios
                                em Excel
                            </p>
                        </div>

                        {/* Form */}
                        <div className="bg-white rounded-lg shadow-lg p-8 mb-8">
                            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                                <BatchInputForm
                                    batchInput={batchInput}
                                    setBatchInput={setBatchInput}
                                    isProcessing={isProcessing}
                                    processingType={processingType}
                                    setProcessingType={setProcessingType}
                                    getInputLineCount={getInputLineCount}
                                />

                                <div>
                                    <Instructions />
                                    <ActionButtons
                                        onProcess={processBatch}
                                        onClear={clearData}
                                        isProcessing={isProcessing}
                                        hasInput={!!batchInput.trim()}
                                    />
                                </div>
                            </div>
                        </div>

                        <ResultsSummary
                            results={results}
                            processingType={processingType}
                        />
                    </div>
                </div>

                <Footer />
            </div>
        </>
    )
}
